module.exports = __webpack_public_path__ + "static/img/banner04.bbae1d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner04.png
// module id = Q2ia
// module chunks = 1